<template>
  <div class="input-group mb-3" id="customer-list">
    <input
      type="text"
      class="form-control"
      :placeholder="placeholder"
      aria-label="Recipient's username"
      aria-describedby="basic-addon2"
      v-model="search"
      @keyup="getCustomer()" 
      @click="hide_list= true"
       
    />
    <div class="input-group-append" @click="getCustomer()">
      <span class="input-group-text">
        <icon icon="search" />
      </span>
    </div> 
    <div class="droplist-customer card shadow-sm p-0" :style="width" v-if="hide_list" 
     v-click-outside="HidePop"
     >
      <VuePerfectScrollbar class="d-customer-scoll mt-2">

        <loading v-if="loading" class="mt-5"></loading>
        <nodata v-if="!loading && customers.length == 0" class="text-center"></nodata>
        <div
          class="d-customer row"
          v-for="customer of customers"
          :key="customer.id" @click="setCustomer(customer)"
          style="
              margin: auto;     
              border-style: dashed !important;
              border-width: 1px;
              border-color: #E4E6EF !important;"
            >
          <div class="col-5">
            <p>
              <strong>{{ customer.name }}</strong>
            </p>
           <p>
              {{ customer.id }}
            </p>
          
          </div>
          <div class="col-7">
            
             <p>
              <icon icon="mail" :size="15" />
              {{ customer.email || "none" }}
            </p>
            <p>
              <icon icon="smartphone" :size="15" /> ​{{
                customer.phone || "none"
              }}
            </p>
            
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>
<style lang="css">
.d-customer-scoll {
    height: 344px; 
}
.droplist-customer {
  position: absolute;
  margin-top: 59px; 
  z-index: 1;
}
.d-customer {
  width: 99%;
  padding-left: 5px;
}
.d-customer:hover {
  background: gainsboro;
}
</style>

<script>
import store from "@/store";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Nodata from './nodata.vue';
export default {
  name: "BaseDropListCustomer",
  props: {
    placeholder: String,
  },
  components: {
    VuePerfectScrollbar,
  
    Nodata},
  data: () => ({
    width: {},
    search: "",
    hide_list: false,
    customer_selected: {}
  }),
  computed: {
   
    restaurant() {
      return store.getters["restaurant/restaurant"];
    },
    loading() {
      return store.getters["receivable/loadingCustomers"];
    },
    customers() {
      return store.getters["receivable/customers"] || [];
    },
   
  },
  methods: {
    async getCustomer() {
        this.hide_list = true
      await store.dispatch("receivable/getCustomers", {
        restaurant_id: this.restaurant.id,
        search: this.search,
      });
    },
    setCustomer(customer) {
        this.hide_list = false
        this.search=  null
        return this.$emit("selected", customer); 
    },
    HidePop(value){
        this.hide_list = false
    } 
  },
  mounted() {
    
    this.width = {
      width: `${
        document.getElementById("customer-list").clientWidth || 0
      }px !important`,
    };
    // this.getCustomer();
  },
};
</script>